import script from "./NotificationSlugModalCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationSlugModalCreator.vue?vue&type=script&setup=true&lang=js"

import "./NotificationSlugModalCreator.vue?vue&type=style&index=0&id=85ac80e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85ac80e0"]])

export default __exports__